import { render, staticRenderFns } from "./popup-create-task.vue?vue&type=template&id=23d42e74&scoped=true"
import script from "./popup-create-task.vue?vue&type=script&lang=js"
export * from "./popup-create-task.vue?vue&type=script&lang=js"
import style0 from "./popup-create-task.vue?vue&type=style&index=0&id=23d42e74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d42e74",
  null
  
)

export default component.exports